// These schemas should match their corresponding DB model in @performyard/models
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AtLeastOneScheduled () {
        return AtLeastOneScheduled;
    },
    get AutoflowEventTrigger () {
        return AutoflowEventTrigger;
    },
    get AutoflowScheduledTrigger () {
        return AutoflowScheduledTrigger;
    },
    get AutoflowTrigger () {
        return AutoflowTrigger;
    },
    get ScheduledOptions () {
        return ScheduledOptions;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const AutoflowEventTrigger = _zod.z.object({
    type: _zod.z.literal("event"),
    event: _zod.z.object({
        // CONCEPT WIP
        type: _zod.z.union([
            _zod.z.literal("created"),
            _zod.z.literal("updated")
        ]),
        resource: _zod.z.object({
            type: _zod.z.string(),
            id: _utilsisomorphic.transformObjectId.or(_zod.z.instanceof(_bson.ObjectId))
        })
    })
});
const ScheduledOptions = _zod.z.object({
    // TODO could this be a union?
    scheduledTime: _zod.z.string().optional(),
    scheduledCron: _zod.z.string().optional(),
    scheduledRate: _zod.z.string().optional()
});
const AtLeastOneScheduled = ScheduledOptions.refine((data)=>{
    const { scheduledTime, scheduledCron, scheduledRate } = data;
    return scheduledTime !== undefined || scheduledCron !== undefined || scheduledRate !== undefined;
}, {
    message: "At least one of scheduledTime, scheduledCron, or scheduledRate must be provided"
});
const AutoflowScheduledTrigger = _zod.z.object({
    type: _zod.z.literal("scheduled"),
    scheduled: _zod.z.object({
        recurring: _zod.z.boolean().default(false),
        expression: _zod.z.object({
            ...ScheduledOptions.pick({
                scheduledTime: true,
                scheduledCron: true,
                scheduledRate: true
            }).shape
        }),
        inauguralTimeDate: _utilsisomorphic.transformDate.or(_zod.z.date()).optional(),
        startTimeDate: _utilsisomorphic.transformDate.or(_zod.z.date()).optional(),
        endTimeDate: _utilsisomorphic.transformDate.or(_zod.z.date()).optional(),
        timezone: _zod.z.string().optional()
    })
});
const AutoflowTrigger = _zod.z.discriminatedUnion("type", [
    AutoflowEventTrigger,
    AutoflowScheduledTrigger
]);
